var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mobile-nav"
  }, [_c('div', {
    staticClass: "mobile-nav__contents"
  }, [_vm._t("default")], 2), _c('div', {
    staticClass: "mobile-nav__overlay",
    on: {
      "click": _vm.mobileNavClose
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }